<template>
	<v-card
		flat
		width="500px"
	>
		<v-card-title class="secondary--text">
			<span>Filtri</span>
			<v-spacer></v-spacer>
		</v-card-title>
		<v-card-text>
			<v-row class="mt-1">
				<v-col>
					<v-select
						v-model="computedTipologie"
						:items="tipologieItems"
						multiple
						small-chips
						clearable
						deletable-chips
						label="Tipologie Cliente"
						outlined
						dense
					></v-select>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-btn
				@click="resetFilters()"
				color="info"
			>
				Azzera filtri
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn
				@click="closeDialog()"
				color="tertiary"
				class="black--text"
			>
				Annulla
			</v-btn>
			<v-btn
				@click="applyFilters()"
				color="secondary"
			>
				Filtra
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {eventBus} from "@/event-bus";
import {mapActions, mapGetters, mapMutations} from "vuex";
export default {
	data() {
		return {
			tipologieItems: ['Associazione di categoria', 'Azienda', 'Consulente'],
			// isLoadingAccountManagers: false,
			// accountManagers: [],
			// defaultFilters: {
			// 	tipologie: null
			// },
			// filters: {
			// 	tipologie: null
			// },
		}
	},
	
	computed: {
		...mapGetters({
			tipologie: 'clientiFilters/tipologie'
		}),
		computedTipologie: {
			get: function () {
				return this.tipologie.value;
			},
			set: function (value) {
				if (value?.length === 0) value = null;
				this.setTipologieNotApplied(value);
			}
		},
	},
	
	methods: {
		...mapMutations({
			setTipologieNotApplied: 'clientiFilters/SET_TIPOLOGIE_NOT_APPLIED'
		}),
		...mapActions({
			applyFiltersAction: 'clientiFilters/applyFilters',
			resetFiltersAction: 'clientiFilters/resetFilters',
		}),
		applyFilters() {
			this.applyFiltersAction();
			// this.$emit('apply-clienti-filters', this.filters);
			this.$emit('reload-clienti');
			this.closeDialog();
		},
		resetFilters() {
			// Object.keys(this.defaultFilters).forEach(k => {
			// 	this.filters[k] = this.defaultFilters[k]
			// });
			// this.$emit('apply-clienti-filters', this.defaultFilters);
			this.resetFiltersAction();
			this.$emit('reload-clienti');
			this.closeDialog();
		},
		closeDialog() {
			this.$emit('close');
		}
	}
}
</script>

<style scoped>

</style>